import { LexiconsState } from './models';

export const defaultState: LexiconsState = {
  isFetching: false,
  isFetchingDeleted: false,
  isMutating: false,
  lexicons: {},
  deletedLexicons: {},
  isDrawerOpen: false,
  // Starts false rather than true: an environment with no registry is discovered by
  // a failed resolve, and defaulting to "not configured" would flash the feature
  // off on every cold load before the first fetch settles.
  isNotConfigured: false,
};

/**
 * Newer-module naming convention: `vtn-<app>-<layer>-<name>`. Older shared
 * modules use bare names (`app`, `player`), but new reducers follow this form.
 */
export const namespace = 'vtn-redact-state-lexicons';

export interface LexiconsStore {
  [namespace]: LexiconsState;
}
